import { atom } from "recoil";

export const webhookBroadcastStatsModalStore = atom({
	key: "webhookBroadcastStatsModalStore",
	default: {
		show: false,
		data: null,
	},
});
